define([
	"dojo/_base/declare",
	"csi/heading/TextController",
	"csi/xml"
], function(declare,TextController,xml) {

	return declare(TextController, {
		_rawValue: null,
		
		_fromHtmlDynamic: function() {
			// summary: store raw value for later use
			this._rawValue = this.editNode.get("value");
			return this.ren.fromHtmlDynamic(this._ctx, this.heading, this.editNode);
		},
		
		_isValueChanged: function() {
			// summary: allow whitespace to indicate change from old to new comment
			return this.inherited(arguments) || (this.newValue != this._rawValue);
		},

		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: change comment to be new
			return this.inherited(arguments).changeAttribute("OldComment", xml.ATTR_BOOLEAN, false);
		}
	});
});